import { ReferFriendsDialog } from '@colonist/clientforge';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../analytics/Analytics.ts';
import { clientI18n } from '../ClientI18n.ts';
import { ReferralProgramUtils } from '../referral/ReferralProgramUtils.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { getLobbyImagePath } from '../ui_utils/Utils.ts';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
const renderReferFriendsDialog = mountDialogUIReactComponent(ReferFriendsDialog);
export async function showReferFriendsDialog(referralReward, userReferralCount) {
    const referralLink = await ReferralProgramUtils.getReferralLinkForSharing();
    const invitesLeft = referralReward.referralCount - userReferralCount;
    const options = {
        ...referralReward.name.options,
        context: 'one'
    };
    const itemCategoryName = clientI18n.t(referralReward.name.key, options).toLowerCase();
    renderReferFriendsDialog({
        rewardImageUrl: getLobbyImagePath(referralReward.image),
        itemCategoryName: itemCategoryName,
        invitesLeft: invitesLeft,
        referralLink: referralLink,
        onCopyLink: ()=>{
            void navigator.clipboard.writeText(referralLink);
            sendCopyLinkAnalytic(referralReward.analyticsPopupSuccess);
        }
    });
    sendCopyLinkAnalytic(referralReward.analyticsPopupTriggered);
}
function sendCopyLinkAnalytic(analyticType) {
    const eventData = {
        type: AnalyticEventType.ReferralAnalytics,
        category: UIUtilsEjsVariables.isUserOnMobile ? AnalyticEventCategory.MobileStoreReferralProgramReferFriends : AnalyticEventCategory.WebStoreReferralProgramReferFriends,
        floatValue: analyticType
    };
    void CA.sendAnalyticEvent(eventData);
}
